import type { Form } from '../../common/types/form';
import { Setting } from '../../common/types/settings';

const advisorForm: Form<Setting> = {
  key: 'advisors',
  title: 'Berater*innen',
  fields: [
    {
      key: 'value',
      label: 'Name',
      fieldTypes: 'text',
      validateIsNotEmpty: true,
    },
  ],
};

export default advisorForm;
